var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIco3 = function SvgIco3(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 68.499 68.499"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "ico3_svg__a",
    x1: 0.636,
    x2: 0.105,
    y1: 0.96,
    y2: 0.072,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff2264"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#feb100"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 18891",
    transform: "translate(.5 .5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.868 62.517h-34A5.374 5.374 0 0 1 9.5 57.149v-23.86a1.789 1.789 0 0 1 3.579 0v23.86a1.791 1.791 0 0 0 1.789 1.789h34a1.789 1.789 0 0 1 0 3.579z",
    "data-name": "Path 32957",
    style: {
      stroke: "#fff",
      fill: "#272f4d"
    },
    transform: "translate(-2.342 1.903)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.407 32.359a1.79 1.79 0 0 1-1.789-1.789v-18.7a1.791 1.791 0 0 0-1.789-1.789H21.77a1.789 1.789 0 0 1 0-3.579h28.058a5.374 5.374 0 0 1 5.372 5.366v18.7a1.79 1.79 0 0 1-1.793 1.791z",
    "data-name": "Path 32958",
    style: {
      stroke: "#fff",
      fill: "#272f4d"
    },
    transform: "translate(-.32 -2.921)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.3 19.008a1.79 1.79 0 0 1-1.789-1.789v-4.175a5.965 5.965 0 1 0-11.93 0v4.175a1.789 1.789 0 0 1-3.579 0v-4.175a9.544 9.544 0 0 1 19.087 0v4.175a1.79 1.79 0 0 1-1.789 1.789z",
    "data-name": "Path 32961",
    style: {
      stroke: "#fff",
      fill: "#272f4d"
    },
    transform: "translate(-2.632 -3.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.956 38.552H8.868A5.374 5.374 0 0 1 3.5 33.184V18.868A5.374 5.374 0 0 1 8.868 13.5h19.088a5.374 5.374 0 0 1 5.368 5.368v14.316a5.374 5.374 0 0 1-5.368 5.368zM8.868 17.079a1.791 1.791 0 0 0-1.789 1.789v14.316a1.791 1.791 0 0 0 1.789 1.789h19.088a1.791 1.791 0 0 0 1.789-1.789V18.868a1.791 1.791 0 0 0-1.789-1.789z",
    "data-name": "Path 32959",
    style: {
      stroke: "#fff",
      fill: "#272f4d"
    },
    transform: "translate(-3.5 -1.57)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.828,
    cy: 3.828,
    r: 3.828,
    "data-name": "Ellipse 1584",
    style: {
      stroke: "#fff",
      fill: "#272f4d"
    },
    transform: "translate(11.084 18.491)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.289 30.738a1.79 1.79 0 0 1-1.789-1.789v-4.078a1.789 1.789 0 0 1 3.579 0v4.078a1.79 1.79 0 0 1-1.79 1.789",
    "data-name": "Path 32960",
    style: {
      fill: "#272f4d"
    },
    transform: "translate(-1.377 .279)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.026 23.079H33.289a1.789 1.789 0 1 1 0-3.579h10.737a1.789 1.789 0 1 1 0 3.579z",
    "data-name": "Path 32962",
    style: {
      stroke: "#fff",
      fill: "#272f4d"
    },
    transform: "translate(1.903 -.413)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.026 29.079H33.289a1.789 1.789 0 0 1 0-3.579h10.737a1.789 1.789 0 0 1 0 3.579z",
    "data-name": "Path 32963",
    style: {
      stroke: "#fff",
      fill: "#272f4d"
    },
    transform: "translate(1.903 .745)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.991 41.079h-16.7a1.789 1.789 0 1 1 0-3.579h16.7a1.789 1.789 0 1 1 0 3.579z",
    "data-name": "Path 32964",
    style: {
      stroke: "#fff",
      fill: "#272f4d"
    },
    transform: "translate(-1.184 3.061)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.991 47.079h-16.7a1.789 1.789 0 1 1 0-3.579h16.7a1.789 1.789 0 1 1 0 3.579z",
    "data-name": "Path 32965",
    style: {
      stroke: "#fff",
      fill: "#272f4d"
    },
    transform: "translate(-1.184 4.218)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m64.005 33.141-13.122-3.578a1.792 1.792 0 0 0-.982.012l-13.123 3.913A1.789 1.789 0 0 0 35.5 35.2v18.086a8.943 8.943 0 0 0 4.663 7.854l9.392 5.123a1.783 1.783 0 0 0 1.713 0l9.393-5.123a8.944 8.944 0 0 0 4.662-7.854V34.867a1.79 1.79 0 0 0-1.319-1.727zm-6.363 11.343-7.158 7.159a1.79 1.79 0 0 1-2.339.167l-4.772-3.579a1.79 1.79 0 1 1 2.148-2.864l3.53 2.648 6.06-6.061a1.789 1.789 0 1 1 2.53 2.53z",
    "data-name": "Path 32966",
    style: {
      fill: "url(#ico3_svg__a)"
    },
    transform: "translate(3.175 2.017)"
  }));
};
export default SvgIco3;